/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Capitalactivity_Tooltip1Inputs */

const en_settings_capitalactivity_tooltip1 = /** @type {(inputs: Settings_Capitalactivity_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capital activity can not be disabled`)
};

/**
* | output |
* | --- |
* | "Capital activity can not be disabled" |
*
* @param {Settings_Capitalactivity_Tooltip1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_capitalactivity_tooltip1 = /** @type {((inputs?: Settings_Capitalactivity_Tooltip1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Capitalactivity_Tooltip1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_capitalactivity_tooltip1(inputs)
});
export { settings_capitalactivity_tooltip1 as "settings_capitalActivity_tooltip" }